import { render, staticRenderFns } from "./viewOrgInfo.vue?vue&type=template&id=17e93828&scoped=true"
import script from "./viewOrgInfo.vue?vue&type=script&lang=js"
export * from "./viewOrgInfo.vue?vue&type=script&lang=js"
import style0 from "./viewOrgInfo.vue?vue&type=style&index=0&id=17e93828&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e93828",
  null
  
)

export default component.exports